export function RentersPage() {
  return <div />
}
